import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SEGMENT_LIST: `${cleanedFilename(__filename)}-segment-list`,
  INSERT_SEGMENT_BUTTON: `${cleanedFilename(__filename)}-insert-segment-button`,
};
